(() => {
  const toggle = document.querySelector('[data-mobile-nav-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const isOpen = nav.classList.contains('is-open');
      nav.classList.toggle('is-open', !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });

    nav.addEventListener('click', (e) => {
      if (e.target.closest('a')) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }
})();
/* Rebuild layer — behaviours ported from the approved previews (2026-08-03).
   Each block is a no-op on pages that lack its markup. */

(function () {
      var entries = Array.prototype.slice.call(document.querySelectorAll(".capability"));
      var images = document.querySelectorAll("[data-platform-img]");
      var textBlock = document.querySelector("[data-platform-text]");
      var mediaLink = document.querySelector("[data-platform-link]");
      var caption = document.querySelector("[data-platform-caption]");
      var desc = document.querySelector("[data-platform-desc]");
      var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var current = null;
      if (!entries.length || !images.length) return;

      function activate(index, captionText, descText) {
        if (index === current) return;
        current = index;
        images.forEach(function (img) {
          img.classList.toggle("is-active", img.getAttribute("data-platform-img") === index);
        });
        entries.forEach(function (entry) {
          entry.classList.toggle("is-active", entry.getAttribute("data-platform") === index);
        });
        if (mediaLink) {
          var activeLink = document.querySelector('.capability[data-platform="' + index + '"] .capability-link');
          if (activeLink) mediaLink.setAttribute("href", activeLink.getAttribute("href"));
        }
        if (!textBlock) return;
        function swap() {
          if (caption && captionText) caption.textContent = captionText;
          if (desc && descText) desc.textContent = descText;
          textBlock.classList.remove("is-fading");
        }
        if (reduceMotion) { swap(); return; }
        textBlock.classList.add("is-fading");
        setTimeout(swap, 250);
      }

      /* The active capability is the last one whose top has crossed the
         middle of the viewport — recomputed on every scroll frame, so the
         image always matches the highlighted heading, even on fast scrolls. */
      function pick() {
        var mid = window.innerHeight / 2;
        var chosen = entries[0];
        entries.forEach(function (el) {
          if (el.getBoundingClientRect().top <= mid) chosen = el;
        });
        activate(
          chosen.getAttribute("data-platform"),
          chosen.getAttribute("data-caption"),
          chosen.getAttribute("data-desc")
        );
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; pick(); });
      }
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll, { passive: true });
      pick();
    })();

(function () {
      var root = document.querySelector("[data-hero-carousel]");
      var hero = root && root.closest(".hero");
      if (!root || !hero) return;

      var slides = Array.prototype.slice.call(root.querySelectorAll("[data-hero-slide]"));
      var dots = Array.prototype.slice.call(hero.querySelectorAll("[data-hero-dot]"));
      if (slides.length < 2) return;

      var INTERVAL = 6000;
      var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var current = 0;
      var timer = null;

      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle("is-active", i === current);
        });
        dots.forEach(function (dot, i) {
          var on = i === current;
          dot.classList.toggle("is-active", on);
          dot.setAttribute("aria-pressed", on ? "true" : "false");
        });
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }
      function start() {
        if (reduceMotion || timer) return;
        timer = setInterval(function () { show(current + 1); }, INTERVAL);
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener("click", function () {
          stop();
          show(i);
        });
      });

      hero.addEventListener("mouseenter", stop);
      hero.addEventListener("mouseleave", start);
      hero.addEventListener("focusin", stop);
      hero.addEventListener("focusout", function (event) {
        if (!hero.contains(event.relatedTarget)) start();
      });
      document.addEventListener("visibilitychange", function () {
        if (document.hidden) { stop(); } else { start(); }
      });

      show(0);
      start();
    })();

(function () {
      if (!("IntersectionObserver" in window)) return;
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      document.documentElement.classList.add("js");
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.1 });
      document.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });
    })();

(function () {
      var links = Array.prototype.slice.call(document.querySelectorAll(".rail-link"));
      if (!links.length) return;
      var chapters = [];
      var byId = {};
      links.forEach(function (link) {
        var id = link.getAttribute("href").slice(1);
        var chapter = document.getElementById(id);
        if (!chapter) return;
        byId[id] = link;
        chapters.push(chapter);
      });
      if (!chapters.length) return;

      function activate(id) {
        links.forEach(function (link) {
          var isActive = link === byId[id];
          link.classList.toggle("is-active", isActive);
          if (isActive) link.setAttribute("aria-current", "true");
          else link.removeAttribute("aria-current");
        });
      }

      /* The active chapter is the last one whose top has crossed the
         42%-viewport line — computed on every scroll frame, so fast
         scrolling can never skip an update. */
      function pick() {
        var line = window.innerHeight * 0.42;
        var chosen = chapters[0];
        chapters.forEach(function (chapter) {
          if (chapter.getBoundingClientRect().top <= line) chosen = chapter;
        });
        activate(chosen.id);
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; pick(); });
      }
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll, { passive: true });
      pick();
    })();
